export function selectElement<T extends Element>(selector: string, execute: (element: T) => void) {
    const list = document.querySelectorAll<T>(selector);
    list.forEach(execute);
}